import { capitalize } from '@repo-level/core-front';
import type { FC } from 'react';
import { ScFormSection } from './styled';

interface FormSectionProps {
  title?: string;
  noMargin?: boolean;
}

export const FormSection: FC<FormSectionProps> = ({
  title,
  noMargin,
  children,
}) => (
  <ScFormSection noMargin={noMargin}>
    {title && <div className="title">{capitalize(title)}</div>}
    {children}
  </ScFormSection>
);
